// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","Link":"Footer_Link__abupq","socialM":"Footer_socialM__dnzXO","parag":"Footer_parag__BnsoT"};